import { render, staticRenderFns } from "./TeacherAttendancePageControl.vue?vue&type=template&id=1f194a98&scoped=true&"
import script from "./TeacherAttendancePageControl.vue?vue&type=script&lang=js&"
export * from "./TeacherAttendancePageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f194a98",
  null
  
)

export default component.exports